module.exports = __webpack_public_path__ + "fonts/Inter-300-latin21.260c81a.woff2";